import React from 'react';

function Textarea({ register, required, name, ...rest }) {
  return (
    <textarea
      name={name}
      ref={register({ required })}
      className="appearance-none bg-products border-2 px-4 py-3 pr-8 focus:outline-none focus:border-slategray focus:bg-white text-slategray focus:outline-none w-full rounded-lg"
      {...rest}
    />
  );
}

export default Textarea;